export const SEARCH_ICONS = {
  BACK_AND_FORTH_ARROW: 'icon-arrow-back-forw',
  FORWARD_ARROW: 'icon-arrow-forw',
};


export const FLIGHT_CLASS = {
  BUSINESS: 'Business',
  ECONOMY: 'Economy',
  FIRST: 'First',
  PREMIUMECONOMY: 'PremiumEconomy'
};
